<template>
    <div class="mx-auto block-margin z-0">
        <input type="file" @change="e => $emit('addNewImages', e.target.files)" multiple class="hidden" id="additionalImages" />
        <div class="w-full">
            <div class="flex w-full ">
                <div class="standard-form-content">
                    <div class="h-[1px]">

                    </div>
                    <div class="z-50 flex flex-col items-start justify-start">
                        <div class="text-[#BD9135] text-[12px] pl-[10px]">Введіть назву вправи</div>
                        <input 
                            :value="elementName" 
                            @change="e => $emit('update:elementName', e.target.value)" 
                            class="bg-[#1e1e1e] pl-[10px] text-white text-[14px] w-[100%] py-[3px] px-[5px] rounded-[6px]"
                            :class="{
                                'border-[#DA4167] border-[3px] ': !validation.elementName,
                                'border-[#474849] border-[1px] m-[3px]': validation.elementName
                            }" 
                            placeholder="Розминка"
                        >
                    </div>
                    <div class="z-50 flex flex-col items-start justify-start">
                        <div class="text-[#BD9135] text-[12px] pl-[10px]">Час виконання</div>
                        <input 
                            :value="time" 
                            @change="e => $emit('update:time', e.target.value)" 
                            class="bg-[#1e1e1e] pl-[10px] text-white text-[14px] w-[100%] py-[3px] px-[5px] rounded-[6px]"
                            type="number"
                            :class="{
                                'border-[#DA4167] border-[3px] ': !validation.time,
                                'border-[#474849] border-[1px] m-[3px]': validation.time
                            }" 
                            placeholder="0.00"
                        >
                    </div>
                </div>
            </div>
            <div class="flex w-full mt-[50px]">
                <div class="standard-form-content">
                    <div class="w-[30%] flex flex-col items-start justify-start">
                        <div class="text-[#BD9135] text-[14px] font-bold">Блок елементів</div>
                        <TrainingElementFolderSelect
                            :model-value="ageGroup"
                            :select-class="{
                                'border-[#DA4167] border-[3px]': !validation.ageGroup,
                                'text-[#8C8C8C]': ageGroup === '',
                            }"
                            @update:model-value="e => $emit('update:ageGroup', e)"
                        />    
                    </div>
                    <div class="z-50 flex items-start justify-between">
                        <div v-if="elementType != 'warmup_ofp' && elementType != 'warmup_sfp' && elementType != 'hitch_ofp'" class="w-[45%]">
                            <div class="text-[#BD9135] text-[12px] pl-[10px]">Кількість підходів</div>
                            <input 
                                :value="approachesNumber" 
                                @change="e => $emit('update:approachesNumber', e.target.value)" 
                                class="bg-[#1e1e1e] border-[#474849] border-[1px] m-[3px] pl-[10px] text-white text-[14px] w-[100%] py-[3px] px-[5px] rounded-[6px]"
                                :class="{
                                    'border-[#DA4167] border-[3px] ': !validation.approachesNumber,
                                    'border-[#474849] border-[1px] m-[3px]': validation.approachesNumber
                                }" 
                                type="number"
                                placeholder="0.00"
                            >
                        </div>
                        <div v-if="elementType != 'warmup_ofp' && elementType != 'warmup_sfp' && elementType != 'hitch_ofp'" class="w-[45%]">
                            <div class="text-[#BD9135] text-[12px] pl-[10px]">Відпочинок між підходами</div>
                            <input 
                                :value="approachesBreak" 
                                @change="e => $emit('update:approachesBreak', e.target.value)" 
                                class="bg-[#1e1e1e] border-[#474849] border-[1px] pl-[10px] text-white text-[14px] w-[100%] py-[3px] px-[5px] rounded-[6px]"
                                :class="{
                                    'border-[#DA4167] border-[3px] ': !validation.approachesBreak,
                                    'border-[#474849] border-[1px] m-[3px]': validation.approachesBreak
                                }" 
                                type="number"
                                placeholder="0.00"
                            >
                        </div>
                    </div>
                    <div v-if="elementType != 'warmup_ofp' && elementType != 'warmup_sfp' && elementType != 'hitch_ofp'" class="flex flex-col items-start justify-start">
                        <div class="text-[#BD9135] text-[12px] pl-[10px]">Напрям елементу</div>
                    
                        <div class="mt-[1px] w-full">
                            <div v-for="orientation in taskOrientations" class="flex justify-between items-center py-[5px] h-[40px]">
                                <div class="w-[70%]">
                                    <div :style="[`background-color: ${orientation.color}; width: max-content;`]" class="rounded-[6px] text-white text-[12px] px-[10px] pb-[2px] pt-[3px]">
                                        {{ orientation.name }}
                                    </div>
                                </div>
                                <div>
                                    <input v-if="orientation.checked" v-model="orientation.percent" type="text" class="bg-[#1e1e1e] border-[#474849] border-[1px] text-center text-white text-[14px] w-[60px] py-[3px] px-[5px] rounded-[6px]" placeholder="0.00">
                                </div>
                                <div class="flex items-center">
                                    <input v-model="orientation.checked" @click="" type="checkbox" class="cursor-pointer">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex w-full mt-[50px]">
                <div class="standard-form-content">
                    <div v-if="elementType != 'warmup_ofp' && elementType != 'warmup_sfp' && elementType != 'hitch_ofp'" class="flex flex-col items-start justify-start">
                        <div class="text-[#BD9135] text-[12px] pl-[10px]">Розмір поля</div>
                        <div class="flex justify-between items-end">
                            <div class="text-white flex items-end w-[35%]">
                                <input 
                                    :value="fieldWidth" 
                                    @change="e => $emit('update:fieldWidth', e.target.value)" 
                                    class="bg-[#1e1e1e] border-[#474849] border-[1px] pl-[10px] text-white text-[14px] w-[100%] py-[3px] px-[5px] rounded-[6px]"
                                    placeholder="0.00"    
                                />
                                <div class="ml-[10px]">м.</div>
                            </div>
                            <div class="text-white">X</div>
                            <div class="text-white flex items-end w-[35%]">
                                <input 
                                    :value="fieldHeight" 
                                    @change="e => $emit('update:fieldHeight', e.target.value)" 
                                    class="bg-[#1e1e1e] border-[#474849] border-[1px] pl-[10px] text-white text-[14px] w-[100%] py-[3px] px-[5px] rounded-[6px]"
                                    placeholder="0.00"
                                />
                                <div class="ml-[10px]">м.</div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col items-start justify-start">
                        <div class="text-[#BD9135] text-[12px] pl-[10px]">Акцент елементу</div>
                        <textarea 
                            :value="accent" 
                            @change="e => $emit('update:accent', e.target.value)" 

                            :class="{
                                'border-[#DA4167] border-[3px] ': !validation.accent,
                                'border-[#474849] border-[1px] m-[3px]': validation.accent
                            }" 
                            rows="2" 
                            class="bg-[#1e1e1e] pl-[10px] text-white text-[14px] w-[100%] py-[3px] px-[5px] rounded-[6px]"
                            placeholder="Пропишіть акцент елементу"   
                        ></textarea>
                    </div>
                </div>
            </div>
            <div class="flex w-full mt-[50px]">
                <div class="standard-form-content">
                    <div>
                        <div>
                            <div class="text-[#BD9135] text-[12px] pl-[10px]">Додайте посилання на відео вправи</div>
                            <div class="flex gap-2 mt-[10px]">
                                <input v-model="newVideoLink" class="bg-[#1e1e1e] border-[#474849] border-[1px] text-white text-[14px] flex-1 py-[3px] px-[5px] rounded-[6px]" placeholder="Посилання">
                                <button type="button" @click="mediaPickerVisible = true" class="px-3 py-1 bg-[#BD9135] hover:bg-[#a77f2b] text-white text-sm rounded-[6px] whitespace-nowrap">З медіа-сервера</button>
                            </div>
                            <MediaServerPicker :visible="mediaPickerVisible" @close="mediaPickerVisible = false" @select="url => {$emit('addNewVideoLink', url); mediaPickerVisible = false}" />
                            <div class="flex mt-[7px]">
                                <div class="mr-[13px] cursor-pointer">
                                    <svg @click="e => {$emit('addNewVideoLink', newVideoLink); newVideoLink = ''}" width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="38" height="38" rx="6" fill="#474849"/>
                                        <rect x="0.5" y="0.5" width="37" height="37" rx="5.5" stroke="#C4C4C4" stroke-opacity="0.8"/>
                                        <path d="M19 11V27" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M11 19H27" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>

                                <div v-for="(link, id) in videos" class="flex ml-[10px] flex-col justify-center">
                                    <div :title="link" @click="openLink(link)" class="cursor-pointer">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.5 12.5L12.5 7.5" stroke="#C59014" stroke-width="1.5" stroke-linecap="round"/>
                                            <path d="M14.8463 12.6095L17.4558 10C19.5147 7.94113 19.5147 4.60303 17.4558 2.54416C15.397 0.485281 12.0589 0.485282 10 2.54416L7.39045 5.1537M12.6095 14.8463L10 17.4558C7.94113 19.5147 4.60303 19.5147 2.54416 17.4558C0.485281 15.397 0.485281 12.0589 2.54416 10L5.1537 7.39045" stroke="#C59014" stroke-width="1.5" stroke-linecap="round"/>
                                        </svg>
                                    </div>
                                    <div class="text-center text-[#474849] mt-[5px]">
                                        <div @click="$emit('deleteLink', id)" class="cursor-pointer">
                                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="8.5" cy="8.5" r="8.5" fill="#FF0000"/>
                                            <line x1="2.83325" y1="8.91663" x2="14.1666" y2="8.91663" stroke="white" stroke-width="2"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-[20px]">
                            <div class="text-[#BD9135] text-[12px] pl-[10px]">Завантажте або створіть схему вправи</div>
                            <div class="flex mt-[7px]">
                                <div class="mr-[13px] cursor-pointer">
                                    <svg @click="selectAdditionalImage" width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="38" height="38" rx="6" fill="#474849"/>
                                        <rect x="0.5" y="0.5" width="37" height="37" rx="5.5" stroke="#C4C4C4" stroke-opacity="0.8"/>
                                        <path d="M19 11V27" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M11 19H27" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>

                                <div>
                                    <div>
                                        <svg v-if="elementId" @click="$router.push('/schemas-table?element_id=' + elementId)" class="cursor-pointer" width="200" height="38" viewBox="0 0 200 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_1483_1117)">
                                                <path d="M194 0H6C2.68629 0 0 2.68629 0 6V32C0 35.3137 2.68629 38 6 38H194C197.314 38 200 35.3137 200 32V6C200 2.68629 197.314 0 194 0Z" fill="#474849"/>
                                                <path d="M194 0.5H6C2.96243 0.5 0.5 2.96243 0.5 6V32C0.5 35.0376 2.96243 37.5 6 37.5H194C197.038 37.5 199.5 35.0376 199.5 32V6C199.5 2.96243 197.038 0.5 194 0.5Z" stroke="#C4C4C4" stroke-opacity="0.8"/>
                                                <path d="M58.2131 25.9176V22.5597H58.7159C58.8608 22.4687 58.9773 22.3239 59.0653 22.125C59.1563 21.9261 59.2301 21.6918 59.2869 21.4219C59.3466 21.152 59.392 20.8608 59.4233 20.5483C59.4574 20.233 59.4872 19.9148 59.5128 19.5938L59.6832 17.4545H64.7031V22.5597H65.7173V25.9176H63.9872V24H59.9858V25.9176H58.2131ZM60.5227 22.5597H62.9901V18.8523H61.2259L61.1577 19.5938C61.1094 20.2926 61.0398 20.8864 60.9489 21.375C60.858 21.8608 60.7159 22.2557 60.5227 22.5597ZM69.7326 24.1278C69.0707 24.1278 68.4982 23.9872 68.0153 23.706C67.5352 23.4219 67.1644 23.027 66.9031 22.5213C66.6417 22.0128 66.511 21.4233 66.511 20.7528C66.511 20.0767 66.6417 19.4858 66.9031 18.9801C67.1644 18.4716 67.5352 18.0767 68.0153 17.7955C68.4982 17.5114 69.0707 17.3693 69.7326 17.3693C70.3945 17.3693 70.9656 17.5114 71.4457 17.7955C71.9286 18.0767 72.3008 18.4716 72.5621 18.9801C72.8235 19.4858 72.9542 20.0767 72.9542 20.7528C72.9542 21.4233 72.8235 22.0128 72.5621 22.5213C72.3008 23.027 71.9286 23.4219 71.4457 23.706C70.9656 23.9872 70.3945 24.1278 69.7326 24.1278ZM69.7411 22.7216C70.0423 22.7216 70.2937 22.6364 70.4954 22.4659C70.6971 22.2926 70.8491 22.0568 70.9513 21.7585C71.0565 21.4602 71.109 21.1207 71.109 20.7401C71.109 20.3594 71.0565 20.0199 70.9513 19.7216C70.8491 19.4233 70.6971 19.1875 70.4954 19.0142C70.2937 18.8409 70.0423 18.7543 69.7411 18.7543C69.4371 18.7543 69.1815 18.8409 68.9741 19.0142C68.7695 19.1875 68.6147 19.4233 68.5096 19.7216C68.4073 20.0199 68.3562 20.3594 68.3562 20.7401C68.3562 21.1207 68.4073 21.4602 68.5096 21.7585C68.6147 22.0568 68.7695 22.2926 68.9741 22.4659C69.1815 22.6364 69.4371 22.7216 69.7411 22.7216ZM73.6232 25.9176V22.5597H74.1261C74.271 22.4687 74.3874 22.3239 74.4755 22.125C74.5664 21.9261 74.6403 21.6918 74.6971 21.4219C74.7567 21.152 74.8022 20.8608 74.8335 20.5483C74.8675 20.233 74.8974 19.9148 74.9229 19.5938L75.0934 17.4545H80.1133V22.5597H81.1275V25.9176H79.3974V24H75.396V25.9176H73.6232ZM75.9329 22.5597H78.4002V18.8523H76.636L76.5678 19.5938C76.5195 20.2926 76.4499 20.8864 76.359 21.375C76.2681 21.8608 76.1261 22.2557 75.9329 22.5597ZM84.0518 24.1236C83.6342 24.1236 83.2621 24.0511 82.9354 23.9062C82.6087 23.7585 82.3501 23.5412 82.1598 23.2543C81.9723 22.9645 81.8786 22.6037 81.8786 22.1719C81.8786 21.8082 81.9453 21.5028 82.0788 21.2557C82.2124 21.0085 82.3942 20.8097 82.6243 20.6591C82.8544 20.5085 83.1158 20.3949 83.4084 20.3182C83.7038 20.2415 84.0135 20.1875 84.3374 20.1562C84.718 20.1165 85.0249 20.0795 85.2578 20.0455C85.4908 20.0085 85.6598 19.9545 85.7649 19.8835C85.87 19.8125 85.9226 19.7074 85.9226 19.5682V19.5426C85.9226 19.2727 85.8374 19.0639 85.6669 18.9162C85.4993 18.7685 85.2607 18.6946 84.951 18.6946C84.6243 18.6946 84.3643 18.767 84.1712 18.9119C83.978 19.054 83.8501 19.233 83.7876 19.4489L82.1087 19.3125C82.1939 18.9148 82.3615 18.571 82.6115 18.2812C82.8615 17.9886 83.1839 17.7642 83.5788 17.608C83.9766 17.4489 84.4368 17.3693 84.9595 17.3693C85.3232 17.3693 85.6712 17.4119 86.0036 17.4972C86.3388 17.5824 86.6357 17.7145 86.8942 17.8935C87.1555 18.0724 87.3615 18.3026 87.5121 18.5838C87.6626 18.8622 87.7379 19.196 87.7379 19.5852V24H86.0163V23.0923H85.9652C85.8601 23.2969 85.7195 23.4773 85.5433 23.6335C85.3672 23.7869 85.1555 23.9077 84.9084 23.9957C84.6612 24.081 84.3757 24.1236 84.0518 24.1236ZM84.5717 22.8707C84.8388 22.8707 85.0746 22.8182 85.2791 22.7131C85.4837 22.6051 85.6442 22.4602 85.7607 22.2784C85.8771 22.0966 85.9354 21.8906 85.9354 21.6605V20.9659C85.8786 21.0028 85.8004 21.0369 85.701 21.0682C85.6044 21.0966 85.495 21.1236 85.3729 21.1491C85.2507 21.1719 85.1286 21.1932 85.0064 21.2131C84.8842 21.2301 84.7734 21.2457 84.674 21.2599C84.4609 21.2912 84.2749 21.3409 84.1158 21.4091C83.9567 21.4773 83.8331 21.5696 83.745 21.6861C83.657 21.7997 83.6129 21.9418 83.6129 22.1122C83.6129 22.3594 83.7024 22.5483 83.8814 22.679C84.0632 22.8068 84.2933 22.8707 84.5717 22.8707ZM88.489 18.8821V17.4545H94.4208V18.8821H92.3114V24H90.5813V18.8821H88.489ZM97.2557 21.6051L99.6122 17.4545H101.402V24H99.6719V19.8366L97.3239 24H95.5213V17.4545H97.2557V21.6051ZM108.592 24.1278C107.922 24.1278 107.345 23.9858 106.862 23.7017C106.382 23.4148 106.012 23.017 105.754 22.5085C105.498 22 105.37 21.4148 105.37 20.7528C105.37 20.0824 105.5 19.4943 105.758 18.9886C106.02 18.4801 106.39 18.0838 106.87 17.7997C107.35 17.5128 107.922 17.3693 108.583 17.3693C109.154 17.3693 109.654 17.473 110.083 17.6804C110.512 17.8878 110.852 18.179 111.102 18.554C111.352 18.929 111.49 19.3693 111.515 19.875H109.802C109.754 19.5483 109.626 19.2855 109.419 19.0866C109.214 18.8849 108.946 18.7841 108.613 18.7841C108.332 18.7841 108.086 18.8608 107.876 19.0142C107.669 19.1648 107.507 19.3849 107.39 19.6747C107.274 19.9645 107.216 20.3153 107.216 20.7273C107.216 21.1449 107.272 21.5 107.386 21.7926C107.502 22.0852 107.666 22.3082 107.876 22.4616C108.086 22.6151 108.332 22.6918 108.613 22.6918C108.821 22.6918 109.007 22.6491 109.172 22.5639C109.339 22.4787 109.477 22.3551 109.585 22.1932C109.696 22.0284 109.768 21.831 109.802 21.6009H111.515C111.487 22.1009 111.35 22.5412 111.106 22.9219C110.865 23.2997 110.531 23.5952 110.105 23.8082C109.679 24.0213 109.174 24.1278 108.592 24.1278ZM114.159 17.4545L115.361 19.7429L116.593 17.4545H118.455L116.559 20.7273L118.506 24H116.652L115.361 21.7372L114.091 24H112.216L114.159 20.7273L112.284 17.4545H114.159ZM122.282 24.1278C121.608 24.1278 121.029 23.9915 120.543 23.7188C120.06 23.4432 119.688 23.054 119.426 22.5511C119.165 22.0455 119.034 21.4474 119.034 20.7571C119.034 20.0838 119.165 19.4929 119.426 18.9844C119.688 18.4759 120.056 18.0795 120.53 17.7955C121.007 17.5114 121.567 17.3693 122.209 17.3693C122.641 17.3693 123.043 17.4389 123.415 17.5781C123.79 17.7145 124.117 17.9205 124.395 18.196C124.676 18.4716 124.895 18.8182 125.051 19.2358C125.208 19.6506 125.286 20.1364 125.286 20.6932V21.1918H119.759V20.0668H123.577C123.577 19.8054 123.52 19.5739 123.407 19.3722C123.293 19.1705 123.135 19.0128 122.934 18.8991C122.735 18.7827 122.503 18.7244 122.239 18.7244C121.963 18.7244 121.719 18.7884 121.506 18.9162C121.296 19.0412 121.131 19.2102 121.012 19.4233C120.892 19.6335 120.831 19.8679 120.828 20.1264V21.196C120.828 21.5199 120.888 21.7997 121.007 22.0355C121.13 22.2713 121.301 22.4531 121.523 22.581C121.745 22.7088 122.007 22.7727 122.311 22.7727C122.513 22.7727 122.698 22.7443 122.865 22.6875C123.033 22.6307 123.176 22.5455 123.296 22.4318C123.415 22.3182 123.506 22.179 123.569 22.0142L125.248 22.125C125.162 22.5284 124.988 22.8807 124.723 23.1818C124.462 23.4801 124.124 23.7131 123.709 23.8807C123.297 24.0455 122.821 24.1278 122.282 24.1278ZM130.34 21.9929L132.113 17.4545H133.493L130.941 24H129.735L127.242 17.4545H128.618L130.34 21.9929ZM128.205 17.4545V24H126.471V17.4545H128.205ZM132.564 24V17.4545H134.277V24H132.564ZM136.568 26.4545C136.338 26.4545 136.122 26.4361 135.92 26.3991C135.721 26.3651 135.556 26.321 135.426 26.267L135.835 24.9119C136.048 24.9773 136.24 25.0128 136.41 25.0185C136.583 25.0241 136.733 24.9844 136.858 24.8991C136.985 24.8139 137.089 24.669 137.169 24.4645L137.275 24.1875L134.927 17.4545H136.836L138.191 22.2614H138.26L139.627 17.4545H141.549L139.005 24.7074C138.883 25.0597 138.717 25.3665 138.507 25.6278C138.299 25.892 138.037 26.0952 137.718 26.2372C137.4 26.3821 137.017 26.4545 136.568 26.4545Z" fill="#BD9135"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1483_1117">
                                                    <rect width="200" height="38" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>

                                    </div>
                                    <div class="flex mt-[5px]">
                                        <div v-for="(image, id) in additionalImages" @click="$emit('openSavedPicture', image)" class="flex cursor-pointer flex-col justify-center">
                                            <div>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.5 10C3.5 6.22876 3.5 4.34315 4.7448 3.17157C5.98959 2 7.99306 2 12 2H12.7727C16.0339 2 17.6645 2 18.7969 2.79784C19.1214 3.02643 19.4094 3.29752 19.6523 3.60289C20.5 4.66867 20.5 6.20336 20.5 9.27273V11.8182C20.5 14.7814 20.5 16.2629 20.0311 17.4462C19.2772 19.3486 17.6829 20.8491 15.6616 21.5586C14.4044 22 12.8302 22 9.68182 22C7.88275 22 6.98322 22 6.26478 21.7478C5.10979 21.3424 4.19875 20.4849 3.76796 19.3979C3.5 18.7217 3.5 17.8751 3.5 16.1818V10Z" stroke="#C59014" stroke-width="1.5" stroke-linejoin="round"/>
                                                    <path d="M20.5 12C20.5 13.8409 19.0076 15.3333 17.1667 15.3333C16.5009 15.3333 15.716 15.2167 15.0686 15.3901C14.4935 15.5442 14.0442 15.9935 13.8901 16.5686C13.7167 17.216 13.8333 18.0009 13.8333 18.6667C13.8333 20.5076 12.3409 22 10.5 22" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8 7H15" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8 11H11" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </div>
                                            <div class="text-center text-[#474849] mt-[5px]">
                                                {{ id + 1 }}
                                            </div>
                                        </div>
                                        <div v-for="(image, id) in newAdditionalImages" @click="$emit('openNewPicture', image)" class="flex cursor-pointer flex-col justify-center">
                                            <div>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.5 10C3.5 6.22876 3.5 4.34315 4.7448 3.17157C5.98959 2 7.99306 2 12 2H12.7727C16.0339 2 17.6645 2 18.7969 2.79784C19.1214 3.02643 19.4094 3.29752 19.6523 3.60289C20.5 4.66867 20.5 6.20336 20.5 9.27273V11.8182C20.5 14.7814 20.5 16.2629 20.0311 17.4462C19.2772 19.3486 17.6829 20.8491 15.6616 21.5586C14.4044 22 12.8302 22 9.68182 22C7.88275 22 6.98322 22 6.26478 21.7478C5.10979 21.3424 4.19875 20.4849 3.76796 19.3979C3.5 18.7217 3.5 17.8751 3.5 16.1818V10Z" stroke="#C59014" stroke-width="1.5" stroke-linejoin="round"/>
                                                    <path d="M20.5 12C20.5 13.8409 19.0076 15.3333 17.1667 15.3333C16.5009 15.3333 15.716 15.2167 15.0686 15.3901C14.4935 15.5442 14.0442 15.9935 13.8901 16.5686C13.7167 17.216 13.8333 18.0009 13.8333 18.6667C13.8333 20.5076 12.3409 22 10.5 22" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8 7H15" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8 11H11" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </div>
                                            <div class="text-center text-[#474849] mt-[5px]">
                                                {{ id + 1 }}
                                            </div>
                                        </div>
                                        <div v-for="(schema, id) in additionalShemas" @click="$emit('openSchema', schema)" class="flex cursor-pointer flex-col justify-center">
                                            <div>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.5 10C3.5 6.22876 3.5 4.34315 4.7448 3.17157C5.98959 2 7.99306 2 12 2H12.7727C16.0339 2 17.6645 2 18.7969 2.79784C19.1214 3.02643 19.4094 3.29752 19.6523 3.60289C20.5 4.66867 20.5 6.20336 20.5 9.27273V11.8182C20.5 14.7814 20.5 16.2629 20.0311 17.4462C19.2772 19.3486 17.6829 20.8491 15.6616 21.5586C14.4044 22 12.8302 22 9.68182 22C7.88275 22 6.98322 22 6.26478 21.7478C5.10979 21.3424 4.19875 20.4849 3.76796 19.3979C3.5 18.7217 3.5 17.8751 3.5 16.1818V10Z" stroke="#C59014" stroke-width="1.5" stroke-linejoin="round"/>
                                                    <path d="M20.5 12C20.5 13.8409 19.0076 15.3333 17.1667 15.3333C16.5009 15.3333 15.716 15.2167 15.0686 15.3901C14.4935 15.5442 14.0442 15.9935 13.8901 16.5686C13.7167 17.216 13.8333 18.0009 13.8333 18.6667C13.8333 20.5076 12.3409 22 10.5 22" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8 7H15" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8 11H11" stroke="#C59014" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </div>
                                            <div class="text-center text-[#474849] mt-[5px]">
                                                {{ id + 1 }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-col items-start justify-start">
                        <div class="text-[#BD9135] text-[12px] pl-[10px]">Опис</div>
                        <textarea 
                            :value="description" 
                            @change="e => $emit('update:description', e.target.value)" 
                            rows="6" 
                            class="bg-[#1e1e1e] border-[#474849] border-[1px] pl-[10px] text-white text-[14px] w-[100%] py-[3px] px-[5px] rounded-[6px]"
                            placeholder="Опис тренування"
                        ></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref, onMounted, watch } from 'vue'
    import { getAllOrientations } from '@/services/apiRequests'
    import ScoreBoard from './ScoreBoard.vue'
    import MediaServerPicker from '@/components/MediaServerPicker.vue'
    import TrainingElementFolderSelect from '@/views/TrainingSummary/components/TrainingElementFolderSelect.vue'
    export default {
        name: 'ExerciseForm',

        props: {
            elementName: {
                type: String,
                default: ''
            },
            scoreboardType: {
                type: String,
                default: ''
            },
            scoreboardStructure: {
                type: Object,
                default: () => {}
            },
            ageGroup: {
                type: String,
                default: ''
            },
            videos: {
                type: Array,
                default: () => []
            },
            description: {
                type: String,
                default: ''
            },
            additionalImages: {
                type: Array,
                default: () => []
            },
            schemas: {
                type: Array,
                default: () => []
            },
            programId: {
                type: String,
                default: ''
            },
            time: {
                type: Number,
                default: 0
            },
            newAdditionalImages: {
                type: Array,
                default: () => []
            },
            validation: {
                type: Object,
                default: () => {}
            },
            additionalShemas: {
                type: Array,
                default: () => []
            },
            elementDirection: {
                type: String,
                default: ''
            },
            approachesNumber: {
                type: Number,
                default: 0
            },
            approachesBreak: {
                type: Number,
                default: 0
            },
            fieldWidth: {
                type: Number,
                default: 0
            },
            fieldHeight: {
                type: Number,
                default: 0
            },
            accent: {
                type: String,
                default: ''
            },
            elementType: {
                type: String,
                default: ''
            },
            elementId: {
                type: String,
                default: ''
            },
            detailDirection: {
                type: String,
                default: ''
            }
        },

        setup(props, { emit }) {
            const selectAdditionalImage = () => {
                document.getElementById('additionalImages').click()
            }

            const taskOrientations = ref([])

            onMounted(async () => {
                const response = await getAllOrientations()
                console.log('getAllOrientations --------> ', response)
                console.log('props.detailDirection --------> ', props.detailDirection)

                const detailDirection = props.detailDirection || []
                taskOrientations.value = response.orientations.map(orientation => {
                    const maybeSavedOrientation = detailDirection.find(item => item.id === orientation.id)
                    console.log('maybeSavedOrientation: ', maybeSavedOrientation)
                    
                    if (maybeSavedOrientation) {
                        return {
                            id: orientation.id,
                            name: orientation.name,
                            color: orientation.color,
                            percent: maybeSavedOrientation.percent,
                            checked: maybeSavedOrientation.checked
                        }
                    }
                    return {
                        id: orientation.id,
                        name: orientation.name,
                        color: orientation.color,
                        percent: null,
                        checked: false
                    }
                })

            })

            const cachedCheckedCount = ref(0)

            watch(() => taskOrientations.value, (newValue) => {
                const checkedCount = newValue.filter(orientation => orientation.checked).length ? newValue.filter(orientation => orientation.checked).length : 1

                console.log('checkedCount: ', checkedCount)
                console.log('cachedCheckedCount: ', cachedCheckedCount.value)

                if (cachedCheckedCount.value != checkedCount) {
                    newValue.forEach(orientation => {
                        orientation.percent = (100 / checkedCount).toFixed(2)
                    })
                } else {
                    newValue.forEach(orientation => {
                        if (orientation.percent == null) {
                            orientation.percent = (100 / checkedCount).toFixed(2)
                        }
                    })
                }

                emit('updateTaskOrientations', newValue)
                cachedCheckedCount.value = checkedCount
            }, { immediate: true, deep: true })

            const newVideoLink = ref('')
            const mediaPickerVisible = ref(false)

            return {
                selectAdditionalImage,
                taskOrientations,
                newVideoLink,
                mediaPickerVisible
            }
        },

        components: {
            ScoreBoard,
            MediaServerPicker,
            TrainingElementFolderSelect
        }
    }
</script>

<style lang="scss" scoped>
    .standard-form-content {
        width: 100%;
        height: 100%;
        padding: 20px;
        background-color: #1e1e1e;
        border-radius: 10px;

        display: flex;
        justify-content: space-between;

        & > div {
            width: 30%;
        }
    }

    .block-margin {
        margin-top: -73px;
    }

    @media screen and (max-width: 1250px) {
        .standard-form-content {
            display: flex;
            flex-direction: column;

            gap: 40px;

            & > div {
                width: 100%;
            }
        }

        .block-margin {
            margin-top: -3px;
        }
    }

    input[type="checkbox"]{
        accent-color: #BD9135;
        background-color: #1e1e1e;
        width: 15px;
        height: 15px;
    }
</style>